import React, { type ReactNode } from 'react';

import Heading from '@atlaskit/heading';
import { Text, type TextProps } from '@atlaskit/primitives/compiled';

type KnowledgeCardPrimaryDescriptionProps = {
	children: ReactNode;
	size: 'full' | 'compact';
	color?: TextProps['color'];
};

export const KnowledgeCardPrimaryDescription = ({
	children,
	size,
	color = 'color.text.brand',
}: KnowledgeCardPrimaryDescriptionProps): React.JSX.Element => {
	return size === 'compact' ? (
		<Heading as="h2" size="xsmall">
			<Text color={color} weight="medium">
				{children}
			</Text>
		</Heading>
	) : (
		<Heading as="h2" size="medium">
			{children}
		</Heading>
	);
};
